import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";

import PotentialSavingTabs from "./tabs";

const Potential: FC = (): ReactElement => {
  return (
    <>
      <PotentialSavingTabs />
      <Outlet />
    </>
  );
};

export default Potential;
